import { ApolloClient, InMemoryCache } from '@apollo/client'
import serverData, { init as initServerData } from 'ppbl/utils/server-data'
import { isEmpty } from 'lodash-es'

if (isEmpty(serverData)) {
  initServerData()
}

const graphqlClient = new ApolloClient({
  uri: `${serverData.requestURI}/graphql`,
  cache: new InMemoryCache(),
  connectToDevTools: true,
  headers: {
    'X-CSRF-Token': serverData._csrf,
  },
})

export default graphqlClient
